var GA4Functions = (function(window, document){
    window.digitalData = window.digitalData || {};

    function pageInfoCommonDetail(labelName) {
        var environment = 'non-production';
        if(FGT_CONFIG === 'Production' && !IS_TEST_LABEL){
            environment = 'production';
        }
        var destinationURL = window.location.href;
        var referringUrl = document.referrer;
        window.digitalData = {
            version : '0.1',
            page: {
                pageInfo:{
                    destinationURL:destinationURL,
                    referringURL:referringUrl,
                    pageName:getPageTitle(labelName),
                    environment: environment,
                    isTestEntity: (environment === 'production') ? 0 : 1,
                    platform:'buy',
                    publisher:'frontgate',
                    personId:(PERSON_ID ? PERSON_ID : null),
                },
                attributes:{
                }
            }

        };
        return window.digitalData;
    }

    function getPageTitle(labelName) {
        var destinationURL = window.location.href;
        var currentPage = destinationURL.substring(destinationURL.lastIndexOf('/') + 1);
        var checkoutSigninForm = document.getElementById('form-checkout-signin');
        var title = (document.title).toLowerCase();
        if (currentPage === 'cart' || currentPage === 'thank_you') {
            currentPage = currentPage.replace(/_/g, ' ');
            title += ' - ' + currentPage.charAt(0).toUpperCase() + currentPage.slice(1);
        } else if (destinationURL.includes('order_history')) {
            title = labelName.charAt(0).toUpperCase() + labelName.slice(1);
            title += (!isNaN(currentPage)) ? ' - Order History Details' : ' - ' + document.title;
        } else if (checkoutSigninForm) {
            title = 'Login/Sign Up Page';
        } else if (destinationURL.match(/\/event\/[^/]+$/)) {
            title = 'Event Details Page';
        } else if (labelName === title) {
            title = 'Festival Landing Page';
        }
    
        return title;
    }
    
    function attachModalListeners() {
        var modal = document.getElementById('modal-signin');
        if (!modal) return;
    
        var oldPageName = '';
    
        // Detach any existing listeners to prevent duplication
        $('#modal-signin').off('show.bs.modal hidden.bs.modal');
    
        // When the modal is shown
        $('#modal-signin').on('show.bs.modal', function () {
            if (!oldPageName) {
                oldPageName = window.digitalData.page.pageInfo.pageName
            }
    
            // Update the pageName for the modal
            window.digitalData.page.pageInfo.pageName = 'Login/Sign Up Page';
        });
    
        // When the modal is hidden
        $('#modal-signin').on('hidden.bs.modal', function () {
            // Reset the pageName to the original value
            window.digitalData.page.pageInfo.pageName = oldPageName;
    
            // Clear oldPageName to avoid interference with future modal actions
            oldPageName = '';
        });
    }
    
    

    function updatePageInfo(data){
        window.digitalData = pageInfoCommonDetail(data.selfAttribute.label);
        window.digitalData.page.attributes.self = data.selfAttribute;
        window.digitalData.page.pageInfo.publisherDivision = data.publisherDivision;

        // Attach modal listeners when updating page info
        attachModalListeners();
    }

    function pushPageViewInfo(){
        window.ceddl = window.ceddl||[];
        window.ceddl.push(['page_view',window.digitalData]);
    }

    function pushAddToCartEvent(){
        if($('#event-details').data('eventtype') === 'list'){
            var totalQuantity = 0;
            var basePriceTotal = 0;
            var feesTotal = 0;
            var transactionTotal = 0;
            var itemsData = [];

            $('.sel-qty').each(function() {
                var quantity = parseInt($(this).val());
                if (quantity > 0) {
                    var ticket = $(this).closest('.ticket-price-section');
                    var basePrice = ticket.data('baseprice');
                    var serviceFeesPrice = ticket.data('serviceprice');
                    var itemData = {
                        price: {
                            basePrice: basePrice.toFixed(2),
                            basePriceValue: basePrice.toFixed(2),
                            voucherCode: ''
                        },
                        quantity: quantity,
                        category: {
                            categoryID: ticket.data('id'),
                            categoryName: ticket.data('eventname')
                        },
                        productInfo: {
                            productID: ticket.data('id') + '-' + $(this).data('tickettypeid'),
                            productName: ticket.find('.xtix-title').text(),
                            productClass: ticket.data('productclass')
                        },
                        attributes: {
                            isPrimaryTicket: (ticket.data('primaryadmission')) ? 'Yes' : 'No',
                            eventDateLocal: ticket.data('eventstartdate'),
                            eventTimeLocal: ticket.data('eventstarttime'),
                            eventOnsaleDateLocal: ticket.data('eventonsalestartdate'),
                            eventOnsaleTimeLocal: ticket.data('eventonsalestarttime')
                        }
                    };
                    totalQuantity += quantity;
                    basePriceTotal += quantity * basePrice;
                    feesTotal += quantity * serviceFeesPrice;
                    transactionTotal = basePriceTotal + feesTotal;
                    itemsData.push(itemData);
                }
            });

            window.digitalData.cart = {
                total: {
                    ticketQuantity: totalQuantity,
                    basePrice: basePriceTotal.toFixed(2),
                    basePriceValue: basePriceTotal.toFixed(2),
                    transactionTotal: transactionTotal.toFixed(2),
                    currency: $('.ticket-price-section').data('currency'),
                    feesTotal: feesTotal.toFixed(2),
                    tax: 0,
                    voucherCode: ''
                },
                attributes: {
                    isResale: 0,
                    inventoryController: 'frontgate',
                },
                item: itemsData
            }
            window.ceddl = window.ceddl||[];
            window.ceddl.push(['add_to_cart' , window.digitalData]);
        }
    }

    function pushViewCart(cartInfo) {
        window.ceddl = window.ceddl||[];
        window.ceddl.push(['view_cart' , Object.assign({}, window.digitalData, cartInfo)]);
    }

    function pushPurchaseInfo(purchaseInfo) {
        window.ceddl = window.ceddl || [];
        window.ceddl.push(['purchase', Object.assign({}, window.digitalData, purchaseInfo)]);
    }

    function pushCheckoutInfo(checkoutStep, data){
        window.ceddl = window.ceddl||[];
        window.ceddl.push([checkoutStep , Object.assign({}, window.digitalData, data)]);
    }

    function waitlistRequest() {
        window.ceddl = window.ceddl || [];
        window.ceddl.push(['waitlist_request', window.digitalData]);
    }

    function pushEventInfo(){
        var productInfo = {
            product: {
                item: []
            }
        };

        $('.ticket-price-section').each(function(){
            var itemData = {
                category: {
                    categoryID: $(this).data('id'),
                    categoryName: $(this).data('eventname')
                },
                productInfo:{
                    productID: $(this).data('id') + '-' + $(this).data('tickettypeid'),
                    productName: $(this).find('.xtix-title').text(),
                    productClass: $(this).data('productclass')
                },
                attributes:{
                    isPrimaryTicket: ($(this).data('primaryadmission')) ? 'Yes' : 'No',
                    eventDateLocal: $(this).data('eventstartdate'),
                    eventTimeLocal: $(this).data('eventstarttime'),
                    eventOnsaleDateLocal: $(this).data('eventonsalestartdate'),
                    eventOnsaleTimeLocal: $(this).data('eventonsalestarttime')
                }
            };

            productInfo.product.item.push(itemData);
        });
        window.ceddl = window.ceddl||[];
        window.ceddl.push(['view_item' , Object.assign({}, window.digitalData, productInfo)]);
    }

    return {
      pageInfoCommonDetail: pageInfoCommonDetail,
      pushPageViewInfo: pushPageViewInfo,
      pushAddToCartEvent: pushAddToCartEvent,
      pushViewCart: pushViewCart,
      pushPurchaseInfo: pushPurchaseInfo,
      updatePageInfo:updatePageInfo,
      pushCheckoutInfo: pushCheckoutInfo,
      pushEventInfo: pushEventInfo,
      waitlistRequest: waitlistRequest
    };

})(window, document);

